import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPasswordPage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [state, setState] = useState({ loading: false, error: "", done: false });
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setState({ loading: true, error: "", done: false });
        try {
            await api.post("/auth/reset-password", { token, new_password: password });
            setState({ loading: false, error: "", done: true });
            setTimeout(() => navigate("/connexion"), 1800);
        } catch (err) {
            setState({ loading: false, error: apiError(err), done: false });
        }
    };

    return (
        <main className="min-h-screen bg-ivory flex items-center justify-center p-6" data-testid="reset-password-page">
            <div className="w-full max-w-md">
                <div className="flex justify-center mb-8"><Link to="/"><Logo /></Link></div>
                <div className="card-light p-8">
                    <h1 className="font-heading font-bold text-ink text-2xl mb-6">Définir un nouveau mot de passe</h1>
                    {!token ? (
                        <p className="text-destructive text-sm">Lien invalide : jeton manquant.</p>
                    ) : state.done ? (
                        <p className="text-forest text-sm" data-testid="reset-success">Mot de passe mis à jour. Redirection vers la connexion…</p>
                    ) : (
                        <form onSubmit={submit} className="space-y-4">
                            <div>
                                <Label htmlFor="np">Nouveau mot de passe (10 caractères minimum)</Label>
                                <Input id="np" type="password" required minLength={10} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
                            </div>
                            {state.error && <p className="text-sm text-destructive" data-testid="reset-error">{state.error}</p>}
                            <Button type="submit" disabled={state.loading} className="w-full bg-forest text-ivory hover:bg-forest-surface font-semibold" data-testid="reset-submit-button">
                                Valider
                            </Button>
                        </form>
                    )}
                </div>
            </div>
        </main>
    );
}
